import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const checkingInventory = createAction(ACTION.CHECKING_INVENTORY.REQUEST);
export const comparingTrackingBill = createAction(ACTION.COMPARING_TRACKING_BILL.REQUEST);
